<template>
  <div v-resize="onResize">
    <slot
      v-if="isViewTable"
      name="table"
      :items="items"
      :loading="isLoading"
      :contentHeightTable="contentHeightTable"
    />
    <loader v-else :is-loading="isLoading">
      <keep-alive>
        <transition name="slide-fade">
          <v-row
            class="pa-3"
            justify="center"
            align="center"
            v-if="items.length === 0"
          >
            <p class="title warning--text">
              {{ generateMessage(`${i18nPath || namespace}.noItems`) }}
            </p>
          </v-row>

          <slot v-else name="cards" :items="items" />
        </transition>
      </keep-alive>
    </loader>
  </div>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import Loader from '@/components/widgets/Loader';
import { mapState } from 'vuex';
import resizable from '@/business/mixins/resizable';

export default {
  name: 'display-items',
  components: { Loader },
  mixins: [resizable],
  props: {
    namespace: {
      type: String,
      required: true,
    },
    i18nPath: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapState({
      items(state, getters) {
        return getters[`${this.namespace}/items`];
      },
      isLoading(state, getters) {
        return getters[`${this.namespace}/isLoadingItems`];
      },
      isViewTable(state, getters) {
        return getters[`${this.namespace}/isViewTable`];
      },
    }),
  },
  methods: {
    generateMessage,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
 {
  transform: translateX(10px);
  opacity: 0;
}
</style>
